import { currentState } from '../state';
import { HandleCollection } from '../state.model';

export function destroyHandle(
    key: string,
    collection: HandleCollection,
): boolean {
    if (collection?.[key] != null) {
        collection[key].destroy();
        // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete collection[key];
        return true;
    }
    return false;
}

export function destroyNewMyFocusHandle(key: string): void {
    const state = currentState();
    destroyHandle(key, state.myFocusHdls);
}

export function destroyNewMyFocusPhraseHandle(key: string): void {
    const state = currentState();
    destroyHandle(key, state.myFocusPhraseHdls);
}
